var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsubscribe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 153,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.25 25.5H12.75v102h127.5v-102zM127.5 46l-51 31.875L25.5 46v-7.75l51 31.875 51-31.875V46z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 39,
    r: 33,
    transform: "rotate(-90 134 39)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134 11c-15.456 0-28 12.544-28 28s12.544 28 28 28 28-12.544 28-28-12.544-28-28-28zm0 50.4c-12.376 0-22.4-10.024-22.4-22.4 0-5.18 1.764-9.94 4.732-13.72l31.388 31.388A22.127 22.127 0 01134 61.4zm17.668-8.68L120.28 21.332A22.127 22.127 0 01134 16.6c12.376 0 22.4 10.024 22.4 22.4 0 5.18-1.764 9.94-4.732 13.72z",
    fill: "#D23228"
  })));
}
export default __webpack_public_path__ + "f8d0b96aefbf2f51efd56a705ccfa2ed.svg";
export { SvgUnsubscribe as ReactComponent };